import axios from "axios";
let mainAxios = axios;
export default mainAxios